export const movies = [
  {
    id: "d01",
    title: "无声的潮汐",
    originalTitle: "침묵의 조수",
    year: 2024,
    type: "drama",
    director: "朴宰勋",
    cast: ["金瑞妍", "李道贤", "郑河俊"],
    duration: 118,
    rating: 9.1,
    views: 48210,
    ageRating: "18+",
    releaseDate: "2024-09-12",
    featured: true,
    tags: ["婚姻", "海边小镇", "秘密", "沉默"],
    synopsis:
      "济州岛东岸的灯塔管理员美京，在丈夫出海失踪的第三年，收到了一封没有寄件人的信。信里只有一张褪色的合照，和一个她从未听过的名字。随着潮水一次次退去，被掩埋的往事开始浮出水面，她必须决定是继续守护这个家的沉默，还是让真相像潮水一样漫过堤岸。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20film%20poster%20key%20art%2C%20a%20woman%20standing%20alone%20on%20a%20windy%20stone%20lighthouse%20pier%20at%20dusk%2C%20charcoal%20grey%20sea%20and%20warm%20amber%20horizon%2C%20moody%20low-key%20lighting%2C%20soft%20film%20grain%2C%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=krfilm-d01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20lonely%20stone%20lighthouse%20on%20a%20dark%20volcanic%20coast%20at%20blue%20hour%2C%20deep%20charcoal%20sea%20with%20warm%20amber%20light%20glow%2C%20mist%20and%20soft%20film%20grain%2C%20atmospheric%20Korean%20art%20house%20cinema%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d01-bd&orientation=landscape"
  },
  {
    id: "d02",
    title: "首尔最后一班地铁",
    originalTitle: "서울 막차",
    year: 2023,
    type: "drama",
    director: "尹智厚",
    cast: ["朴昭熙", "崔成宇", "韩素拉"],
    duration: 106,
    rating: 8.6,
    views: 39120,
    ageRating: "18+",
    releaseDate: "2023-11-03",
    featured: false,
    tags: ["都市", "夜班", "陌生人", "救赎"],
    synopsis:
      "末班地铁的车厢里，三个陌生人因为一场临时停运被困在一起。失业的调酒师、刚结束一段婚姻的护士、以及一个抱着旧吉他的少年，在四十分钟的黑暗里交换了彼此最不愿提起的夜晚。天亮之后，他们各自回到自己的生活，却发现那趟列车改变了某些东西。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20Korean%20urban%20drama%20film%20poster%2C%20empty%20late-night%20subway%20carriage%20with%20warm%20amber%20ceiling%20lights%2C%20lone%20silhouette%20seated%20by%20the%20window%2C%20charcoal%20and%20rust%20color%20palette%2C%20cinematic%20low-key%20lighting%2C%20soft%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20interior%20of%20an%20empty%20Seoul%20subway%20carriage%20at%20midnight%2C%20amber%20strip%20lights%20reflecting%20on%20dark%20windows%2C%20deep%20charcoal%20shadows%2C%20lonely%20atmospheric%20film%20still%2C%20subtle%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-d02-bd&orientation=landscape"
  },
  {
    id: "d03",
    title: "雨落北村",
    originalTitle: "북촌의 비",
    year: 2022,
    type: "drama",
    director: "姜允书",
    cast: ["徐恩彩", "白承勋", "金瑞妍"],
    duration: 124,
    rating: 8.8,
    views: 35640,
    ageRating: "18+",
    releaseDate: "2022-06-18",
    featured: true,
    tags: ["旧宅", "家族", "遗产", "雨"],
    synopsis:
      "北村韩屋老宅即将被拆除，分散多年的三兄妹被迫回到这里清点遗物。在阁楼的木箱里，他们发现了母亲年轻时的日记，以及一个从未出现在家谱上的名字。连绵的雨季里，关于偏爱、隐瞒与原谅的往事，一点点渗进这座老屋的墙缝。",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20Korean%20family%20drama%20poster%2C%20traditional%20hanok%20courtyard%20in%20heavy%20rain%2C%20warm%20lantern%20glow%20against%20charcoal%20grey%20walls%2C%20wet%20stone%20path%2C%20cinematic%20melancholy%2C%20muted%20amber%20tones%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20rainy%20evening%20in%20a%20traditional%20Korean%20hanok%20neighborhood%2C%20warm%20amber%20paper%20lanterns%2C%20wet%20tile%20roofs%20and%20dark%20wood%2C%20shallow%20depth%20of%20field%2C%20moody%20art%20house%20film%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d03-bd&orientation=landscape"
  },
  {
    id: "d04",
    title: "母亲的第二封信",
    originalTitle: "어머니의 두 번째 편지",
    year: 2021,
    type: "drama",
    director: "吴泰京",
    cast: ["韩素拉", "郑河俊", "车秀彬"],
    duration: 112,
    rating: 8.4,
    views: 28930,
    ageRating: "12+",
    releaseDate: "2021-05-20",
    featured: false,
    tags: ["亲情", "和解", "故乡", "书信"],
    synopsis:
      "在首尔做编剧的智安，十年没有回过老家。母亲去世后，她收到了一封被邮局退回的信——寄件人是母亲，收件人却是她从未听说过的一个地址。沿着这条线索，她重新走了一遍母亲的人生，也第一次看清了自己逃离的原因。",
    poster:
      "https://readdy.ai/api/search-image?query=Tender%20Korean%20family%20drama%20poster%2C%20an%20old%20wooden%20desk%20with%20stacked%20handwritten%20letters%20and%20a%20single%20warm%20desk%20lamp%2C%20charcoal%20room%2C%20amber%20light%2C%20nostalgic%20quiet%20mood%2C%20cinematic%20still%20life%2C%20soft%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Korean%20countryside%20house%20interior%20at%20dusk%2C%20old%20wooden%20desk%20with%20letters%20and%20a%20glowing%20lamp%2C%20charcoal%20shadows%2C%20amber%20window%20light%2C%20intimate%20cinematic%20film%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d04-bd&orientation=landscape"
  },
  {
    id: "d05",
    title: "冬柏花开时",
    originalTitle: "동백이 피는 밤",
    year: 2024,
    type: "drama",
    director: "崔成宇",
    cast: ["金瑞妍", "尹智厚", "朴昭熙"],
    duration: 131,
    rating: 9.2,
    views: 61240,
    ageRating: "18+",
    releaseDate: "2024-10-04",
    featured: true,
    tags: ["岛屿", "复仇", "女性", "悬疑"],
    synopsis:
      "南海小岛上的冬柏旅馆，住着一位从不提起过去的老板娘。当一名纪录片导演带着摄影机到来，岛上维持了二十年的平静被打破。花开的那一夜，有人终于说出当年那场火灾的真相，也有人选择用余生去偿还。",
    poster:
      "https://readdy.ai/api/search-image?query=Striking%20Korean%20drama%20film%20poster%2C%20woman%20in%20a%20dark%20coat%20standing%20among%20red%20camellia%20flowers%20at%20night%2C%20deep%20charcoal%20background%2C%20warm%20amber%20rim%20light%2C%20mysterious%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20scene%20of%20a%20small%20Korean%20island%20guesthouse%20surrounded%20by%20camellia%20bushes%2C%20warm%20window%20glow%20against%20deep%20charcoal%20blue%20darkness%2C%20mist%20over%20the%20sea%2C%20cinematic%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=krfilm-d05-bd&orientation=landscape"
  },
  {
    id: "d06",
    title: "汉江以南",
    originalTitle: "한강 이남",
    year: 2020,
    type: "drama",
    director: "李道贤",
    cast: ["白承勋", "徐恩彩", "吴泰京"],
    duration: 119,
    rating: 8.2,
    views: 24180,
    ageRating: "15+",
    releaseDate: "2020-09-25",
    featured: false,
    tags: ["拆迁", "底层", "父子", "城市"],
    synopsis:
      "汉江以南的老旧公寓区被划入重建计划，靠修鞋为生的父亲和开夜班出租的儿子，为了多拿一点补偿款，开始了一场漫长而荒诞的拉锯。当推土机终于开到楼下，他们才发现真正舍不得的不是房子。",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20Korean%20social%20drama%20poster%2C%20old%20low-rise%20apartment%20blocks%20in%20grey%20rain%2C%20single%20amber%20window%20lit%2C%20utility%20poles%20and%20narrow%20alley%2C%20charcoal%20tones%2C%20documentary%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=krfilm-d06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20old%20Seoul%20apartment%20blocks%20south%20of%20the%20Han%20River%20at%20overcast%20dusk%2C%20warm%20scattered%20window%20lights%2C%20muted%20charcoal%20palette%2C%20social%20realism%20film%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d06-bd&orientation=landscape"
  },
  {
    id: "d07",
    title: "消失的第九天",
    originalTitle: "사라진 아흐레",
    year: 2023,
    type: "drama",
    director: "朴宰勋",
    cast: ["郑河俊", "韩素拉", "尹智厚"],
    duration: 127,
    rating: 8.7,
    views: 33150,
    ageRating: "18+",
    releaseDate: "2023-03-17",
    featured: false,
    tags: ["失踪", "调查", "小镇", "谎言"],
    synopsis:
      "高中教师在下班后失踪，九天后又被发现安然回到家中，只是完全不记得这九天发生了什么。小镇上的人开始用各自的版本填满这段空白，而负责此案的刑警发现，每一个版本都在保护同一个人。",
    poster:
      "https://readdy.ai/api/search-image?query=Psychological%20Korean%20thriller%20poster%2C%20blurred%20figure%20walking%20down%20a%20foggy%20small-town%20street%20at%20dawn%2C%20harsh%20amber%20streetlamp%2C%20deep%20charcoal%20shadows%2C%20uneasy%20cinematic%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Foggy%20Korean%20small%20town%20street%20before%20sunrise%2C%20amber%20streetlamp%20cones%20of%20light%2C%20empty%20road%20and%20low%20buildings%2C%20charcoal%20blue%20haze%2C%20eerie%20cinematic%20thriller%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d07-bd&orientation=landscape"
  },
  {
    id: "d08",
    title: "房间里的海",
    originalTitle: "방 안의 바다",
    year: 2022,
    type: "drama",
    director: "姜允书",
    cast: ["朴昭熙", "金瑞妍", "车秀彬"],
    duration: 98,
    rating: 8.5,
    views: 27640,
    ageRating: "18+",
    releaseDate: "2022-01-14",
    featured: false,
    tags: ["密闭空间", "心理", "母女", "疗愈"],
    synopsis:
      "一位患有广场恐惧症的插画师，把自己关在能看到海的房间里已经两年。当多年未见的母亲带着行李出现在门口，两个人的生活被迫重叠。她们用沉默、争吵和一顿顿饭，重新学习如何相处。",
    poster:
      "https://readdy.ai/api/search-image?query=Intimate%20Korean%20chamber%20drama%20poster%2C%20minimal%20room%20with%20a%20large%20window%20framing%20a%20grey%20sea%2C%20curtain%20moving%20in%20wind%2C%20warm%20amber%20afternoon%20light%2C%20charcoal%20interior%2C%20quiet%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=krfilm-d08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Calm%20minimal%20Korean%20apartment%20room%20with%20floor-to-ceiling%20window%20overlooking%20a%20pale%20grey%20winter%20sea%2C%20warm%20amber%20late%20afternoon%20light%2C%20soft%20curtains%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d08-bd&orientation=landscape"
  },
  {
    id: "d09",
    title: "白夜里的丈夫",
    originalTitle: "백야의 남편",
    year: 2021,
    type: "drama",
    director: "吴泰京",
    cast: ["崔成宇", "徐恩彩", "李道贤"],
    duration: 115,
    rating: 8.3,
    views: 21980,
    ageRating: "18+",
    releaseDate: "2021-08-06",
    featured: false,
    tags: ["婚姻", "背叛", "失眠", "都市"],
    synopsis:
      "连续三个月失眠的男人，开始在深夜的城市里游荡。他遇见了各种各样的人，也悄悄跟踪着自己的妻子。当两个人在同一家便利店门口相遇，他们都明白，有些事情已经不需要再问。",
    poster:
      "https://readdy.ai/api/search-image?query=Nocturnal%20Korean%20relationship%20drama%20poster%2C%20man%20in%20an%20open%20coat%20standing%20in%20a%20convenience%20store%20glow%20at%203am%2C%20empty%20dark%20street%2C%20amber%20and%20charcoal%20palette%2C%20lonely%20cinematic%20mood%2C%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20Seoul%20street%20at%20three%20in%20the%20morning%2C%20warm%20amber%20convenience%20store%20light%20spilling%20onto%20wet%20asphalt%2C%20deep%20charcoal%20shadows%2C%20cinematic%20urban%20loneliness%2C%20no%20text&width=1600&height=900&seq=krfilm-d09-bd&orientation=landscape"
  },
  {
    id: "d10",
    title: "归途三千里",
    originalTitle: "삼천리 귀향",
    year: 2019,
    type: "drama",
    director: "李道贤",
    cast: ["白承勋", "韩素拉", "吴泰京"],
    duration: 136,
    rating: 8.0,
    views: 18420,
    ageRating: "12+",
    releaseDate: "2019-10-11",
    featured: false,
    tags: ["公路", "离散", "乡土", "时代"],
    synopsis:
      "七十岁的老人执意要独自坐长途车回到北方老家，儿子只好请假陪同。三千里的路上，父子俩第一次有时间把所有没说的话说完。车窗外掠过的，是几代人都没能留住的风景。",
    poster:
      "https://readdy.ai/api/search-image?query=Reflective%20Korean%20road%20movie%20poster%2C%20elderly%20man%20and%20adult%20son%20seen%20from%20behind%20at%20a%20rural%20bus%20stop%2C%20warm%20amber%20dusk%20light%2C%20charcoal%20hills%20and%20dry%20grass%2C%20wistful%20cinematic%20tone%2C%20no%20text&width=600&height=900&seq=krfilm-d10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20rural%20Korean%20highway%20at%20golden%20dusk%2C%20dry%20autumn%20grass%20and%20distant%20charcoal%20hills%2C%20small%20bus%20stop%2C%20warm%20amber%20light%2C%20cinematic%20road%20movie%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d10-bd&orientation=landscape"
  },
  {
    id: "d11",
    title: "半透明的夏天",
    originalTitle: "반투명의 여름",
    year: 2024,
    type: "drama",
    director: "尹智厚",
    cast: ["徐恩彩", "车秀彬", "金瑞妍"],
    duration: 103,
    rating: 8.6,
    views: 30210,
    ageRating: "18+",
    releaseDate: "2024-07-19",
    featured: false,
    tags: ["青春", "成长", "夏天", "告别"],
    synopsis:
      "复读第三年的女孩在补习班里遇见了一个只在下午出现的男生。他们约定不谈过去，也不问将来，只共享这个夏天。等到开学的那天，她才发现有些相遇本来就是为了告别。",
    poster:
      "https://readdy.ai/api/search-image?query=Hazy%20Korean%20coming-of-age%20film%20poster%2C%20two%20teenagers%20on%20a%20sunlit%20staircase%20seen%20through%20translucent%20curtain%2C%20warm%20amber%20summer%20haze%2C%20soft%20charcoal%20shadows%2C%20nostalgic%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-d11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunlit%20Korean%20high%20school%20stairwell%20in%20late%20summer%2C%20dust%20motes%20in%20warm%20amber%20light%2C%20translucent%20white%20curtains%2C%20empty%20nostalgic%20frame%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=krfilm-d11-bd&orientation=landscape"
  },
  {
    id: "d12",
    title: "老屋的灯",
    originalTitle: "오래된 집의 등불",
    year: 2018,
    type: "drama",
    director: "朴宰勋",
    cast: ["韩素拉", "郑河俊", "白承勋"],
    duration: 110,
    rating: 7.9,
    views: 15630,
    ageRating: "12+",
    releaseDate: "2018-12-07",
    featured: false,
    tags: ["故乡", "守夜", "记忆", "亲情"],
    synopsis:
      "在城里做护工的女人回到乡下，为独居的父亲办理入住养老院的手续。三天的时间里，她修好了漏雨的屋顶，也重新点亮了那盏二十年没换过灯泡的门廊灯。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20restrained%20Korean%20family%20drama%20poster%2C%20small%20rural%20house%20with%20a%20single%20glowing%20porch%20lamp%20surrounded%20by%20dark%20trees%2C%20amber%20light%20and%20charcoal%20night%2C%20quiet%20cinematic%20still%2C%20no%20text&width=600&height=900&seq=krfilm-d12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Old%20Korean%20countryside%20house%20at%20night%20with%20a%20single%20warm%20amber%20porch%20light%2C%20dense%20dark%20trees%2C%20stone%20wall%2C%20peaceful%20melancholy%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d12-bd&orientation=landscape"
  },
  {
    id: "d13",
    title: "她的名字叫顺姬",
    originalTitle: "그녀의 이름은 순희",
    year: 2020,
    type: "drama",
    director: "姜允书",
    cast: ["金瑞妍", "朴昭熙", "徐恩彩"],
    duration: 121,
    rating: 8.5,
    views: 25870,
    ageRating: "18+",
    releaseDate: "2020-04-24",
    featured: false,
    tags: ["女性", "身份", "年代", "抗争"],
    synopsis:
      "从工厂女工到小餐馆老板，顺姬用四十年时间把自己活成了别人口中的“能干女人”。当孙女在整理旧物时翻出一张工会合影，她第一次讲起那个被改名、被遗忘、也曾经站在最前面的自己。",
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20Korean%20womens%20drama%20poster%2C%20portrait%20of%20a%20middle-aged%20woman%20in%20a%20warm%20kitchen%20with%20steam%20and%20amber%20light%2C%20charcoal%20background%2C%20dignified%20expression%2C%20vintage%20film%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20retro%20Korean%20kitchen%20of%20a%20small%20eatery%2C%20steam%20rising%20in%20amber%20light%2C%20old%20aluminum%20pots%2C%20charcoal%20shadowed%20walls%2C%20nostalgic%20cinematic%20film%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d13-bd&orientation=landscape"
  },
  {
    id: "d14",
    title: "凌晨四点的便利店",
    originalTitle: "새벽 네 시 편의점",
    year: 2023,
    type: "drama",
    director: "吴泰京",
    cast: ["尹智厚", "韩素拉", "李道贤"],
    duration: 96,
    rating: 8.1,
    views: 22340,
    ageRating: "15+",
    releaseDate: "2023-02-10",
    featured: false,
    tags: ["夜班", "群像", "都市", "温柔"],
    synopsis:
      "凌晨四点的便利店里，夜班店员见过喝醉的上班族、逃家的少年、以及每天来买同一种饭团的老人。这一夜，他决定不再只是收钱和说欢迎光临。",
    poster:
      "https://readdy.ai/api/search-image?query=Intimate%20Korean%20slice-of-life%20film%20poster%2C%20bright%20convenience%20store%20window%20at%20dawn%20seen%20from%20dark%20street%2C%20warm%20amber%20interior%20glow%2C%20charcoal%20exterior%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=krfilm-d14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20Korean%20convenience%20store%20glowing%20warm%20amber%20on%20a%20dark%20empty%20street%20before%20dawn%2C%20reflections%20on%20wet%20pavement%2C%20cinematic%20urban%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d14-bd&orientation=landscape"
  },
  {
    id: "d15",
    title: "雪停之后",
    originalTitle: "눈이 그친 뒤",
    year: 2022,
    type: "drama",
    director: "崔成宇",
    cast: ["车秀彬", "郑河俊", "朴昭熙"],
    duration: 108,
    rating: 8.4,
    views: 20760,
    ageRating: "15+",
    releaseDate: "2022-12-16",
    featured: false,
    tags: ["冬天", "重逢", "旧友", "山城"],
    synopsis:
      "一场大雪封住了进山的路，五个多年未见的老同学被困在同一间民宿。他们打牌、喝酒、假装什么都没变，直到有人提起那个所有人都回避的名字。",
    poster:
      "https://readdy.ai/api/search-image?query=Snowy%20Korean%20ensemble%20drama%20poster%2C%20small%20mountain%20guesthouse%20with%20warm%20amber%20windows%20in%20deep%20snow%2C%20blue%20charcoal%20twilight%2C%20bare%20trees%2C%20quiet%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-d15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Snow-covered%20Korean%20mountain%20village%20at%20dusk%2C%20warm%20amber%20lights%20from%20a%20small%20guesthouse%2C%20dark%20pine%20trees%2C%20mist%20and%20falling%20snow%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=krfilm-d15-bd&orientation=landscape"
  },
  {
    id: "d16",
    title: "借来的父亲",
    originalTitle: "빌려온 아버지",
    year: 2019,
    type: "drama",
    director: "李道贤",
    cast: ["白承勋", "金瑞妍", "吴泰京"],
    duration: 114,
    rating: 8.3,
    views: 19850,
    ageRating: "12+",
    releaseDate: "2019-06-21",
    featured: false,
    tags: ["亲情", "扮演", "谎言", "温情"],
    synopsis:
      "为了让病重的奶奶安心，一个年轻人雇了一位临时演员来扮演自己多年未归的父亲。三个月的相处里，这场谎言变得越来越真实，直到所有人都开始舍不得拆穿。",
    poster:
      "https://readdy.ai/api/search-image?query=Heartwarming%20Korean%20family%20drama%20poster%2C%20two%20men%20sitting%20side%20by%20side%20on%20a%20hospital%20corridor%20bench%2C%20warm%20amber%20light%20and%20long%20charcoal%20shadows%2C%20restrained%20emotion%2C%20cinematic%20still%2C%20no%20text&width=600&height=900&seq=krfilm-d16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20Korean%20hospital%20corridor%20at%20late%20afternoon%2C%20warm%20amber%20sunlight%20through%20tall%20windows%2C%20empty%20bench%2C%20muted%20charcoal%20tones%2C%20cinematic%20film%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d16-bd&orientation=landscape"
  },
  {
    id: "d17",
    title: "七年之痒的第七年",
    originalTitle: "일곱 해째",
    year: 2021,
    type: "drama",
    director: "朴宰勋",
    cast: ["韩素拉", "崔成宇", "徐恩彩"],
    duration: 105,
    rating: 8.2,
    views: 24310,
    ageRating: "18+",
    releaseDate: "2021-11-12",
    featured: false,
    tags: ["婚姻", "倦怠", "对话", "现实"],
    synopsis:
      "结婚第七年，他们决定在离婚协议上签字前，先去一次当年蜜月旅行的小岛。四天三夜的行程里，两个人把这七年重新过了一遍，也第一次认真听完对方的话。",
    poster:
      "https://readdy.ai/api/search-image?query=Mature%20Korean%20marriage%20drama%20poster%2C%20two%20people%20sitting%20apart%20on%20a%20quiet%20beach%20at%20dusk%2C%20warm%20amber%20horizon%2C%20charcoal%20sand%20and%20sea%2C%20restrained%20cinematic%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20Korean%20beach%20at%20low%20tide%20during%20sunset%2C%20two%20distant%20silhouettes%20sitting%20apart%2C%20warm%20amber%20sky%20over%20charcoal%20sea%2C%20cinematic%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=krfilm-d17-bd&orientation=landscape"
  },
  {
    id: "d18",
    title: "深海来信",
    originalTitle: "심해에서 온 편지",
    year: 2024,
    type: "drama",
    director: "姜允书",
    cast: ["郑河俊", "朴昭熙", "白承勋"],
    duration: 122,
    rating: 8.8,
    views: 36780,
    ageRating: "18+",
    releaseDate: "2024-04-26",
    featured: false,
    tags: ["潜水", "失踪", "海洋", "记忆"],
    synopsis:
      "潜水教练在一次事故后失去了部分记忆，却不断收到署名是他自己的信。信里描述着一片他从未下潜过的海域，以及一个被所有人否认存在过的女孩。",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20Korean%20mystery%20drama%20poster%2C%20diver%20silhouette%20descending%20into%20deep%20dark%20water%20with%20a%20shaft%20of%20warm%20amber%20light%20from%20above%2C%20charcoal%20blues%2C%20cinematic%20scale%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Underwater%20cinematic%20wide%20shot%20in%20deep%20dark%20sea%2C%20single%20shaft%20of%20warm%20amber%20sunlight%20penetrating%20from%20surface%2C%20suspended%20particles%2C%20deep%20charcoal%20water%2C%20mysterious%20mood%2C%20no%20text&width=1600&height=900&seq=krfilm-d18-bd&orientation=landscape"
  },
  {
    id: "d19",
    title: "芦苇荡的黄昏",
    originalTitle: "갈대밭의 황혼",
    year: 2017,
    type: "drama",
    director: "吴泰京",
    cast: ["韩素拉", "李道贤", "车秀彬"],
    duration: 101,
    rating: 7.8,
    views: 12430,
    ageRating: "15+",
    releaseDate: "2017-10-27",
    featured: false,
    tags: ["乡村", "晚年", "遗忘", "陪伴"],
    synopsis:
      "老伴患上阿尔茨海默症后，老人每天带她去同一片芦苇荡散步，讲同一个故事。当她已经完全认不出他，他决定再讲一遍，从他们第一次见面开始。",
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20Korean%20film%20poster%2C%20elderly%20couple%20walking%20hand%20in%20hand%20through%20tall%20silver%20reeds%20at%20dusk%2C%20warm%20amber%20backlight%2C%20charcoal%20shadows%2C%20gentle%20cinematic%20melancholy%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-d19&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20Korean%20reed%20field%20at%20sunset%2C%20warm%20amber%20light%20glowing%20through%20silver%20plumes%2C%20two%20tiny%20figures%20walking%20a%20narrow%20path%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=krfilm-d19-bd&orientation=landscape"
  },
  {
    id: "d20",
    title: "空房间的回声",
    originalTitle: "빈방의 메아리",
    year: 2023,
    type: "drama",
    director: "崔成宇",
    cast: ["徐恩彩", "尹智厚", "金瑞妍"],
    duration: 117,
    rating: 8.5,
    views: 26490,
    ageRating: "18+",
    releaseDate: "2023-08-25",
    featured: false,
    tags: ["独居", "录音", "孤独", "都市"],
    synopsis:
      "声音设计师搬进一间租金异常便宜的老公寓，发现夜里总能录到不属于自己的呼吸声。她开始顺着声音寻找上一位住客，也在这个过程中听见了自己一直回避的孤独。",
    poster:
      "https://readdy.ai/api/search-image?query=Unsettling%20Korean%20psychological%20drama%20poster%2C%20empty%20dim%20apartment%20room%20with%20a%20microphone%20stand%20and%20a%20sliver%20of%20amber%20light%20under%20the%20door%2C%20charcoal%20shadows%2C%20cinematic%20tension%2C%20no%20text&width=600&height=900&seq=krfilm-d20&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dim%20empty%20Korean%20apartment%20room%20at%20night%2C%20soft%20amber%20light%20under%20a%20door%20and%20through%20thin%20curtains%2C%20bare%20floor%2C%20deep%20charcoal%20tones%2C%20cinematic%20eerie%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d20-bd&orientation=landscape"
  },
  {
    id: "d21",
    title: "沉默的证词",
    originalTitle: "침묵의 증언",
    year: 2022,
    type: "drama",
    director: "朴宰勋",
    cast: ["郑河俊", "白承勋", "韩素拉"],
    duration: 129,
    rating: 8.7,
    views: 31520,
    ageRating: "18+",
    releaseDate: "2022-09-30",
    featured: false,
    tags: ["法庭", "真相", "代价", "人性"],
    synopsis:
      "一桩十年前的旧案重新开庭，唯一的目击者却拒绝出庭。当年负责记录的书记员如今成了法官，她必须在程序正义与自己知道的真相之间做出选择。",
    poster:
      "https://readdy.ai/api/search-image?query=Serious%20Korean%20legal%20drama%20poster%2C%20empty%20courthouse%20bench%20lit%20by%20a%20single%20warm%20amber%20lamp%2C%20stacks%20of%20case%20files%2C%20deep%20charcoal%20wood%2C%20cinematic%20chiaroscuro%2C%20no%20text&width=600&height=900&seq=krfilm-d21&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20Korean%20courtroom%20after%20hours%2C%20warm%20amber%20desk%20lamp%20glow%20on%20dark%20wood%20bench%2C%20empty%20gallery%20seats%2C%20charcoal%20shadows%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d21-bd&orientation=landscape"
  },
  {
    id: "d22",
    title: "最后一个春天",
    originalTitle: "마지막 봄",
    year: 2020,
    type: "drama",
    director: "尹智厚",
    cast: ["金瑞妍", "车秀彬", "崔成宇"],
    duration: 113,
    rating: 8.4,
    views: 23860,
    ageRating: "12+",
    releaseDate: "2020-03-13",
    featured: false,
    tags: ["告别", "病痛", "春天", "温柔"],
    synopsis:
      "得知自己只剩一个春天的花艺师，决定把剩下的时间用来完成一份名单：那些她一直想道歉、想感谢、想再见一面的人。名单上的最后一项，是她自己。",
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20Korean%20melodrama%20poster%2C%20florist%20arranging%20pale%20spring%20flowers%20in%20a%20dim%20charcoal%20shop%2C%20warm%20amber%20window%20light%2C%20soft%20petals%20in%20air%2C%20bittersweet%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-d22&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20spring%20afternoon%20inside%20a%20small%20Korean%20flower%20shop%2C%20amber%20sunlight%20through%20steamy%20windows%2C%20pale%20blossoms%2C%20charcoal%20wooden%20shelves%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-d22-bd&orientation=landscape"
  },
  {
    id: "r01",
    title: "午夜电台的告白",
    originalTitle: "자정의 라디오",
    year: 2024,
    type: "romance",
    director: "姜允书",
    cast: ["朴昭熙", "李道贤", "徐恩彩"],
    duration: 111,
    rating: 8.9,
    views: 42670,
    ageRating: "18+",
    releaseDate: "2024-02-14",
    featured: true,
    tags: ["电台", "暗恋", "声音", "夜"],
    synopsis:
      "深夜电台主持人每天都会接到同一个匿名来电，对方只点一首歌，从不多说。直到某天节目停播，她在整理旧带子时，听出了那个声音属于谁。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20late-night%20radio%20film%20poster%2C%20woman%20with%20headphones%20in%20a%20dim%20studio%2C%20warm%20amber%20VU%20meter%20glow%2C%20deep%20charcoal%20background%2C%20intimate%20cinematic%20mood%2C%20soft%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-r01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20dark%20radio%20broadcast%20studio%20at%20midnight%2C%20warm%20amber%20control%20panel%20lights%2C%20microphone%20in%20foreground%2C%20charcoal%20shadows%2C%20intimate%20cinematic%20film%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r01-bd&orientation=landscape"
  },
  {
    id: "r02",
    title: "我们之间的距离",
    originalTitle: "우리 사이의 거리",
    year: 2023,
    type: "romance",
    director: "吴泰京",
    cast: ["韩素拉", "郑河俊", "车秀彬"],
    duration: 104,
    rating: 8.5,
    views: 29840,
    ageRating: "15+",
    releaseDate: "2023-05-19",
    featured: false,
    tags: ["异地", "书信", "重逢", "现实"],
    synopsis:
      "一个在首尔，一个在釜山，他们把三年的感情都放进每周一次的视频通话里。当距离终于被缩短，他们却发现最难跨越的，是彼此已经习惯的生活节奏。",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20Korean%20long-distance%20romance%20poster%2C%20split%20framing%20of%20two%20people%20lit%20by%20phone%20screens%20in%20dark%20rooms%2C%20warm%20amber%20and%20charcoal%20tones%2C%20tender%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-r02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Two%20dark%20apartment%20windows%20glowing%20warm%20amber%20at%20night%20in%20a%20city%20skyline%2C%20rain%20on%20glass%2C%20charcoal%20tones%2C%20romantic%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r02-bd&orientation=landscape"
  },
  {
    id: "r03",
    title: "桑拿房的夏天",
    originalTitle: "사우나의 여름",
    year: 2022,
    type: "romance",
    director: "崔成宇",
    cast: ["金瑞妍", "白承勋", "朴昭熙"],
    duration: 99,
    rating: 8.3,
    views: 25120,
    ageRating: "18+",
    releaseDate: "2022-08-12",
    featured: false,
    tags: ["老街", "熟人", "暧昧", "夏日"],
    synopsis:
      "老街的桑拿房即将关门，老板的女儿从外地回来帮忙收拾。她和常来泡澡的邮差在闷热的蒸汽里，说起了二十年前那个谁也没说出口的夏天。",
    poster:
      "https://readdy.ai/api/search-image?query=Steamy%20nostalgic%20Korean%20romance%20poster%2C%20warm%20amber%20light%20through%20thick%20steam%20in%20an%20old%20sauna%2C%20tiled%20charcoal%20walls%2C%20soft%20silhouette%2C%20sensual%20restrained%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-r03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Old%20Korean%20neighborhood%20sauna%20interior%20filled%20with%20steam%2C%20warm%20amber%20light%20through%20small%20window%2C%20dark%20tiled%20walls%2C%20atmospheric%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r03-bd&orientation=landscape"
  },
  {
    id: "r04",
    title: "第二次心动",
    originalTitle: "두 번째 설렘",
    year: 2021,
    type: "romance",
    director: "尹智厚",
    cast: ["徐恩彩", "李道贤", "韩素拉"],
    duration: 107,
    rating: 8.1,
    views: 21460,
    ageRating: "15+",
    releaseDate: "2021-07-09",
    featured: false,
    tags: ["再婚", "中年", "温柔", "家庭"],
    synopsis:
      "独自带大女儿的女人，在四十岁那年遇见了一个总在公园喂流浪猫的男人。两个都受过伤的人小心翼翼地靠近，却先要面对孩子们比想象中更复杂的目光。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20mature%20Korean%20romance%20poster%2C%20two%20adults%20walking%20in%20a%20leafy%20park%20at%20golden%20hour%2C%20stray%20cat%20on%20a%20bench%2C%20amber%20light%20and%20charcoal%20shadows%2C%20gentle%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-r04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20Korean%20city%20park%20at%20golden%20hour%2C%20warm%20amber%20light%20through%20trees%2C%20empty%20bench%2C%20soft%20haze%2C%20romantic%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r04-bd&orientation=landscape"
  },
  {
    id: "r05",
    title: "海边旅馆的房客",
    originalTitle: "해변 여관의 손님",
    year: 2024,
    type: "romance",
    director: "朴宰勋",
    cast: ["朴昭熙", "郑河俊", "金瑞妍"],
    duration: 120,
    rating: 8.8,
    views: 38290,
    ageRating: "18+",
    releaseDate: "2024-06-07",
    featured: true,
    tags: ["海边", "旅人", "错过", "治愈"],
    synopsis:
      "淡季的海边旅馆只住着一位长期房客，他每天写一封不寄出的信。新来的打工女孩无意间读到了其中一封，发现信里写的那个人，很像三年前的自己。",
    poster:
      "https://readdy.ai/api/search-image?query=Melancholic%20Korean%20seaside%20romance%20poster%2C%20small%20weathered%20guesthouse%20on%20an%20empty%20beach%20at%20dusk%2C%20warm%20amber%20window%20light%2C%20charcoal%20grey%20sea%20and%20sky%2C%20cinematic%20quiet%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-r05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Lonely%20Korean%20seaside%20guesthouse%20at%20off-season%20dusk%2C%20warm%20amber%20windows%2C%20pale%20grey%20sand%20and%20sea%2C%20overcast%20sky%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=krfilm-r05-bd&orientation=landscape"
  },
  {
    id: "r06",
    title: "雨季不再来",
    originalTitle: "다시 오지 않는 장마",
    year: 2020,
    type: "romance",
    director: "姜允书",
    cast: ["韩素拉", "崔成宇", "吴泰京"],
    duration: 102,
    rating: 8.0,
    views: 18930,
    ageRating: "15+",
    releaseDate: "2020-07-17",
    featured: false,
    tags: ["雨季", "初恋", "旧地", "释怀"],
    synopsis:
      "雨季的第一天，她在整理要卖掉的旧公寓时，遇见了十年没见的初恋。两个人被困在停电的楼里一整天，把当年没说完的话，一句一句补了回来。",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Korean%20rainy%20romance%20poster%2C%20two%20silhouettes%20standing%20under%20a%20narrow%20eaves%20during%20heavy%20rain%2C%20warm%20amber%20streetlamp%2C%20charcoal%20wet%20walls%2C%20tender%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-r06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Korean%20apartment%20alley%20in%20heavy%20summer%20rain%2C%20warm%20amber%20streetlamp%20reflections%20on%20wet%20concrete%2C%20dark%20charcoal%20tones%2C%20romantic%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r06-bd&orientation=landscape"
  },
  {
    id: "r07",
    title: "她的香水味",
    originalTitle: "그녀의 향수",
    year: 2022,
    type: "romance",
    director: "吴泰京",
    cast: ["金瑞妍", "李道贤", "徐恩彩"],
    duration: 109,
    rating: 8.4,
    views: 27380,
    ageRating: "18+",
    releaseDate: "2022-04-15",
    featured: false,
    tags: ["气味", "记忆", "重逢", "都市"],
    synopsis:
      "调香师在首尔的地铁里闻到一种久违的气味，那是他十年前为一个人调的香。为了找到她，他做了一件很傻的事：在同一个时间，坐同一班车，坐了一整个月。",
    poster:
      "https://readdy.ai/api/search-image?query=Sensual%20Korean%20romance%20film%20poster%2C%20glass%20perfume%20bottle%20catching%20warm%20amber%20light%20on%20a%20dark%20vanity%2C%20sheer%20fabric%20and%20soft%20shadow%2C%20charcoal%20background%2C%20elegant%20cinematic%20still%20life%2C%20no%20text&width=600&height=900&seq=krfilm-r07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20Seoul%20subway%20platform%20at%20night%2C%20warm%20amber%20lights%20reflected%20on%20polished%20dark%20floor%2C%20motion%20blur%20of%20commuters%2C%20romantic%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r07-bd&orientation=landscape"
  },
  {
    id: "r08",
    title: "星期五的约定",
    originalTitle: "금요일의 약속",
    year: 2023,
    type: "romance",
    director: "崔成宇",
    cast: ["车秀彬", "朴昭熙", "白承勋"],
    duration: 97,
    rating: 8.2,
    views: 22610,
    ageRating: "15+",
    releaseDate: "2023-09-08",
    featured: false,
    tags: ["约定", "餐馆", "日常", "陪伴"],
    synopsis:
      "他们说好每个星期五在同一家小馆子吃顿饭，不谈感情，也不问对方的生活。这个约定坚持了两年，直到某个星期五，其中一个人没有出现。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20Korean%20romantic%20drama%20poster%2C%20cozy%20small%20restaurant%20table%20for%20two%20with%20steaming%20dishes%2C%20amber%20pendant%20lamp%20glow%2C%20charcoal%20interior%2C%20cinematic%20intimacy%2C%20no%20text&width=600&height=900&seq=krfilm-r08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20intimate%20Korean%20restaurant%20at%20night%2C%20empty%20table%20set%20for%20two%2C%20warm%20amber%20pendant%20lights%2C%20dark%20charcoal%20wood%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r08-bd&orientation=landscape"
  },
  {
    id: "r09",
    title: "旧唱片店",
    originalTitle: "오래된 음반 가게",
    year: 2019,
    type: "romance",
    director: "李道贤",
    cast: ["徐恩彩", "郑河俊", "韩素拉"],
    duration: 100,
    rating: 7.9,
    views: 16740,
    ageRating: "12+",
    releaseDate: "2019-04-05",
    featured: false,
    tags: ["音乐", "怀旧", "小店", "暗恋"],
    synopsis:
      "唱片店老板坚持只卖黑胶，直到隔壁开了家数字音乐体验店。来店里避雨的常客女孩，成了这场固执守卫战里唯一的听众，也成了他不敢说出口的理由。",
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20Korean%20romance%20poster%2C%20crates%20of%20vinyl%20records%20in%20a%20dim%20shop%2C%20warm%20amber%20lamp%20and%20dust%20motes%2C%20charcoal%20shelves%2C%20nostalgic%20cinematic%20still%2C%20no%20text&width=600&height=900&seq=krfilm-r09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dim%20vintage%20Korean%20record%20shop%20interior%2C%20warm%20amber%20lamp%20over%20crates%20of%20vinyl%2C%20narrow%20aisle%2C%20charcoal%20wood%20shelves%2C%20nostalgic%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r09-bd&orientation=landscape"
  },
  {
    id: "r10",
    title: "不能说的名字",
    originalTitle: "말할 수 없는 이름",
    year: 2021,
    type: "romance",
    director: "尹智厚",
    cast: ["金瑞妍", "白承勋", "车秀彬"],
    duration: 118,
    rating: 8.6,
    views: 30920,
    ageRating: "18+",
    releaseDate: "2021-03-26",
    featured: false,
    tags: ["禁忌", "身份", "抉择", "情感"],
    synopsis:
      "他是她最好的朋友的前任，也是她默默记了很多年的人。当三个人因为一场婚礼重新聚在同一座城市，所有被小心维持的界限都开始变得模糊。",
    poster:
      "https://readdy.ai/api/search-image?query=Restrained%20Korean%20romantic%20drama%20poster%2C%20woman%20in%20an%20evening%20dress%20standing%20alone%20on%20a%20hotel%20balcony%20at%20night%2C%20warm%20amber%20interior%20light%20behind%20her%2C%20charcoal%20city%20beyond%2C%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-r10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Korean%20hotel%20wedding%20reception%20at%20night%2C%20warm%20amber%20chandelier%20glow%20over%20empty%20tables%2C%20glass%20windows%20reflecting%20charcoal%20city%20lights%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r10-bd&orientation=landscape"
  },
  {
    id: "r11",
    title: "清晨六点的吻",
    originalTitle: "새벽 여섯 시의 입맞춤",
    year: 2022,
    type: "romance",
    director: "朴宰勋",
    cast: ["韩素拉", "吴泰京", "朴昭熙"],
    duration: 94,
    rating: 8.3,
    views: 19250,
    ageRating: "18+",
    releaseDate: "2022-10-21",
    featured: false,
    tags: ["清晨", "短暂", "相遇", "遗憾"],
    synopsis:
      "值夜班的护士和送报纸的男人，每天清晨六点在同一个路口擦肩而过。他们从没说过话，却在彼此的生活里留下了越来越清晰的痕迹。",
    poster:
      "https://readdy.ai/api/search-image?query=Tender%20Korean%20dawn%20romance%20poster%2C%20two%20people%20passing%20each%20other%20on%20an%20empty%20city%20crosswalk%20at%20first%20light%2C%20warm%20amber%20sunrise%20haze%2C%20charcoal%20silhouettes%2C%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-r11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20Korean%20city%20crosswalk%20at%20dawn%2C%20warm%20amber%20sunrise%20haze%20between%20charcoal%20buildings%2C%20soft%20mist%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-r11-bd&orientation=landscape"
  },
  {
    id: "r12",
    title: "秋天结束前",
    originalTitle: "가을이 끝나기 전에",
    year: 2024,
    type: "romance",
    director: "姜允书",
    cast: ["徐恩彩", "李道贤", "韩素拉"],
    duration: 106,
    rating: 8.7,
    views: 34170,
    ageRating: "15+",
    releaseDate: "2024-11-01",
    featured: false,
    tags: ["秋天", "限期", "告别", "治愈"],
    synopsis:
      "她只在这座城市待到秋天结束。他们约好不谈未来，也不留联系方式，只是在银杏落尽之前，认真地把每一天过完。",
    poster:
      "https://readdy.ai/api/search-image?query=Golden%20autumn%20Korean%20romance%20poster%2C%20couple%20walking%20under%20ginkgo%20trees%20showered%20in%20warm%20amber%20leaves%2C%20charcoal%20park%20path%2C%20bittersweet%20cinematic%20mood%2C%20soft%20grain%2C%20no%20text&width=600&height=900&seq=krfilm-r12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Korean%20city%20park%20avenue%20of%20golden%20ginkgo%20trees%20in%20late%20autumn%2C%20warm%20amber%20light%2C%20fallen%20leaves%20on%20dark%20path%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=krfilm-r12-bd&orientation=landscape"
  },
  {
    id: "s01",
    title: "楼上的邻居",
    originalTitle: "윗집 사람",
    year: 2023,
    type: "society",
    director: "吴泰京",
    cast: ["郑河俊", "韩素拉", "白承勋"],
    duration: 116,
    rating: 8.5,
    views: 27840,
    ageRating: "18+",
    releaseDate: "2023-01-20",
    featured: false,
    tags: ["噪音", "邻里", "冲突", "城市"],
    synopsis:
      "楼上的脚步声持续了两年，投诉、调解、报警都没有结果。当独居的楼下住户决定自己解决这件事，整栋楼隐藏的矛盾一并被掀开。",
    poster:
      "https://readdy.ai/api/search-image?query=Tense%20Korean%20urban%20drama%20poster%2C%20ceiling%20of%20a%20dim%20apartment%20with%20a%20single%20harsh%20amber%20light%20and%20long%20shadows%2C%20cracked%20plaster%2C%20charcoal%20tones%2C%20cinematic%20unease%2C%20no%20text&width=600&height=900&seq=krfilm-s01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20view%20of%20a%20dense%20Korean%20apartment%20block%20facade%2C%20scattered%20warm%20amber%20windows%2C%20deep%20charcoal%20concrete%2C%20cinematic%20urban%20isolation%2C%20no%20text&width=1600&height=900&seq=krfilm-s01-bd&orientation=landscape"
  },
  {
    id: "s02",
    title: "沉默的合同",
    originalTitle: "침묵의 계약",
    year: 2022,
    type: "society",
    director: "崔成宇",
    cast: ["白承勋", "徐恩彩", "尹智厚"],
    duration: 125,
    rating: 8.6,
    views: 30150,
    ageRating: "18+",
    releaseDate: "2022-11-18",
    featured: false,
    tags: ["职场", "合约", "秘密", "权力"],
    synopsis:
      "刚入职的年轻员工发现公司要求所有人签一份“自愿放弃加班费”的协议。她试图反抗，却发现连最亲近的同事，都在这份沉默的合同上按下了手印。",
    poster:
      "https://readdy.ai/api/search-image?query=Cold%20Korean%20corporate%20drama%20poster%2C%20empty%20glass%20office%20meeting%20room%20at%20night%2C%20one%20warm%20amber%20desk%20lamp%2C%20stacks%20of%20paperwork%2C%20charcoal%20and%20grey%20palette%2C%20cinematic%20still%2C%20no%20text&width=600&height=900&seq=krfilm-s02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20empty%20Korean%20corporate%20office%20at%20night%2C%20rows%20of%20silent%20desks%2C%20warm%20amber%20light%20from%20one%20room%2C%20city%20lights%20through%20glass%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-s02-bd&orientation=landscape"
  },
  {
    id: "s03",
    title: "被删掉的采访",
    originalTitle: "삭제된 인터뷰",
    year: 2024,
    type: "society",
    director: "尹智厚",
    cast: ["金瑞妍", "朴昭熙", "李道贤"],
    duration: 128,
    rating: 8.9,
    views: 39720,
    ageRating: "18+",
    releaseDate: "2024-08-23",
    featured: true,
    tags: ["媒体", "真相", "压力", "选择"],
    synopsis:
      "一段足以改变舆论走向的采访素材，在播出前夜被人从服务器删除。记者必须在四十八小时内找回它，同时面对来自上级、当事人和自己良心的三重压力。",
    poster:
      "https://readdy.ai/api/search-image?query=Investigative%20Korean%20media%20thriller%20poster%2C%20editing%20suite%20with%20a%20single%20monitor%20glowing%20warm%20amber%20in%20deep%20charcoal%20darkness%2C%20timeline%20of%20footage%2C%20tense%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-s03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20Korean%20newsroom%20editing%20bay%20at%20night%2C%20warm%20amber%20monitor%20glow%20on%20empty%20desks%2C%20charcoal%20shadows%2C%20investigative%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-s03-bd&orientation=landscape"
  },
  {
    id: "s04",
    title: "江南区的另一面",
    originalTitle: "강남의 이면",
    year: 2020,
    type: "society",
    director: "朴宰勋",
    cast: ["崔成宇", "车秀彬", "韩素拉"],
    duration: 133,
    rating: 8.4,
    views: 26510,
    ageRating: "18+",
    releaseDate: "2020-11-06",
    featured: false,
    tags: ["阶层", "欲望", "城市", "群像"],
    synopsis:
      "一名代驾司机每晚穿梭在江南区的霓虹之间，载过醉酒的投资人、练习生和独居的老人。他记录下每一个地址，也记录下这座城市如何把人们分成两边。",
    poster:
      "https://readdy.ai/api/search-image?query=Neon%20noir%20Korean%20urban%20drama%20poster%2C%20lone%20figure%20in%20a%20car%20under%20dense%20warm%20amber%20neon%20reflections%2C%20rain-streaked%20windshield%2C%20charcoal%20night%20city%2C%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=krfilm-s04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20Gangnam%20street%20at%20night%20seen%20from%20inside%20a%20car%2C%20warm%20amber%20neon%20smears%20on%20wet%20glass%2C%20deep%20charcoal%20shadows%2C%20cinematic%20noir%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-s04-bd&orientation=landscape"
  },
  {
    id: "s05",
    title: "证人的房间",
    originalTitle: "증인의 방",
    year: 2021,
    type: "society",
    director: "姜允书",
    cast: ["韩素拉", "郑河俊", "徐恩彩"],
    duration: 119,
    rating: 8.7,
    views: 28390,
    ageRating: "18+",
    releaseDate: "2021-09-10",
    featured: false,
    tags: ["调查", "保护", "恐惧", "抉择"],
    synopsis:
      "一名关键证人在安全屋里住了七个月，窗外是普通的小区，窗内是二十四小时监控。当她说出自己其实记错了那天晚上发生的事，整个案件的走向开始崩塌。",
    poster:
      "https://readdy.ai/api/search-image?query=Claustrophobic%20Korean%20drama%20poster%2C%20narrow%20safehouse%20room%20with%20blinds%20cutting%20warm%20amber%20light%20into%20stripes%2C%20charcoal%20walls%2C%20lone%20chair%2C%20cinematic%20tension%2C%20no%20text&width=600&height=900&seq=krfilm-s05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20safehouse%20room%20at%20dusk%2C%20venetian%20blinds%20casting%20warm%20amber%20light%20stripes%20across%20a%20bare%20wall%2C%20charcoal%20interior%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=krfilm-s05-bd&orientation=landscape"
  },
  {
    id: "s06",
    title: "一座城的良心",
    originalTitle: "한 도시의 양심",
    year: 2019,
    type: "society",
    director: "李道贤",
    cast: ["白承勋", "吴泰京", "金瑞妍"],
    duration: 141,
    rating: 8.5,
    views: 21180,
    ageRating: "15+",
    releaseDate: "2019-12-13",
    featured: false,
    tags: ["工业", "事故", "家属", "漫长"],
    synopsis:
      "十年前的一场工厂事故改变了一座小城的所有家庭，赔偿协议签完，人们以为事情结束了。直到一位母亲在儿子的遗物里，发现了另一份从未公开的检测报告。",
    poster:
      "https://readdy.ai/api/search-image?query=Somber%20Korean%20social%20drama%20poster%2C%20industrial%20harbor%20silhouette%20at%20dusk%20with%20warm%20amber%20sky%2C%20single%20figure%20walking%20along%20a%20dark%20pier%2C%20charcoal%20tones%2C%20cinematic%20scale%2C%20no%20text&width=600&height=900&seq=krfilm-s06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Korean%20industrial%20harbor%20at%20dusk%2C%20cranes%20and%20factory%20silhouettes%20against%20warm%20amber%20sky%2C%20dark%20charcoal%20water%2C%20somber%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=krfilm-s06-bd&orientation=landscape"
  }
];